import { useNavigate } from 'react-router-dom';

const INDUSTRIES = [
  {
    icon: 'ri-home-4-line',
    title: 'Roofing',
    tag: 'Repairs · Replacement · Storm Damage',
    pains: [
      'Storm leads going to whoever answers first',
      'Invisible when homeowners ask AI for a roofer',
      'High ad spend on tire-kicker quotes',
    ],
  },
  {
    icon: 'ri-drop-line',
    title: 'Plumbing',
    tag: 'Emergency · Repair · Repipe · Water Heaters',
    pains: [
      'After-hours emergencies ringing out unanswered',
      'Not recommended in AI search results',
      'Losing urgent jobs to faster competitors',
    ],
  },
  {
    icon: 'ri-temp-cold-line',
    title: 'HVAC',
    tag: 'AC Repair · Install · Maintenance',
    pains: [
      'Peak-season calls missed during the rush',
      'Invisible when AI recommends an AC company',
      'Ad budget burned on unqualified leads',
    ],
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Restoration',
    tag: 'Water · Fire · Mold Remediation',
    pains: [
      "24/7 emergencies you can't afford to miss",
      'Not surfacing in AI for "water damage near me"',
      'Slow response losing high-value claims',
    ],
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Electrical',
    tag: 'Repair · Panels · Generators · EV',
    pains: [
      'Missed calls while crews are on the job',
      'Invisible when AI suggests an electrician',
      'Competitors winning the AI-search era first',
    ],
  },
  {
    icon: 'ri-archive-drawer-line',
    title: 'Garage Door Repair',
    tag: 'Springs · Openers · Install',
    pains: [
      'Same-day jobs lost to whoever picks up',
      'Not recommended when customers ask AI',
      'Paying for leads that never convert',
    ],
  },
];

export default function WhoWeHelp() {
  const navigate = useNavigate();

  return (
    <section
      id="industries"
      className="relative py-28 overflow-hidden bg-gradient-to-b from-white via-teal-50/40 to-white"
    >
      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="eyebrow reveal">Who We Help</div>
          <h2 className="mt-5 h-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] reveal">
            Built for Florida<br />Home Service Pros.
          </h2>
          <p className="mt-6 text-slate-600 font-body font-light text-base md:text-lg reveal">
            We work exclusively with home service businesses that live and die on call volume,
            response speed, and local visibility.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {INDUSTRIES.map((ind) => (
            <div key={ind.title} className="glass rounded-3xl p-7 reveal">
              <div className="icon-pill mb-4">
                <i className={`${ind.icon} text-teal-500 text-lg`}></i>
              </div>
              <h3 className="h-display text-2xl md:text-3xl leading-tight">{ind.title}</h3>
              <p className="mt-2 text-xs uppercase tracking-wider text-teal-600 font-body font-bold">
                {ind.tag}
              </p>
              <ul className="mt-5 space-y-3 text-sm text-slate-600 font-body font-light">
                {ind.pains.map((pain) => (
                  <li key={pain} className="flex gap-2">
                    <i className="ri-close-circle-line text-orange-500 mt-0.5 shrink-0"></i>
                    {pain}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 reveal">
          <button
            onClick={() => navigate('/audit')}
            className="glass-strong inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm text-slate-800 font-body font-semibold"
          >
            Get Your Free AI Check <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
